'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$state", "ProjectService", "UrlRoutingFactory", function InvestigateStateChangeFactory($state, ProjectService, UrlRoutingFactory) {
    return {
        investigateInDetail: investigateInDetail,
        goToOverview: goToOverview
    };

    function investigateInDetail(train, tab) {
        var viewTab = UrlRoutingFactory.get('view-tab');
        if(util.isDefined(tab)){
            $state.go(`monitoring-detail`, {'projectId': train.projectId, 'trainId': train.trainId, 'tab': tab, 'view-tab': viewTab});
        } else {
            $state.go('monitoring-detail', {'projectId': train.projectId, 'trainId': train.trainId, 'view-tab': viewTab});
        }
    }

    function goToOverview() {
        $state.go('monitoring', {'projectId': ProjectService.getSelectedProjectId(), 'view-tab' : UrlRoutingFactory.get('view-tab')});
    }
}];
